import React, { lazy } from 'react';
import { motion } from 'framer-motion';
// Using simpleicons.org CDN — brand SVGs served by slug.
// Omitting the color path segment returns each brand's official color.
const slug = (s: string) => `https://cdn.simpleicons.org/${s}`;
const logos = [
// User-requested core platforms
{
  name: 'Salesforce',
  src: slug('salesforce')
}, {
  name: 'HubSpot',
  src: slug('hubspot')
}, {
  name: 'Zoom',
  src: slug('zoom')
}, {
  name: 'Microsoft Teams',
  src: slug('microsoftteams')
}, {
  name: 'Figma',
  src: slug('figma')
}, {
  name: 'Snowflake',
  src: slug('snowflake')
}, {
  name: 'Slack',
  src: slug('slack')
}, {
  name: 'Google Workspace',
  src: slug('googleworkspace')
}, {
  name: 'Microsoft Office',
  src: slug('microsoftoffice')
}, {
  name: 'ZoomInfo',
  src: slug('zoominfo')
}, {
  name: 'Dropbox',
  src: slug('dropbox')
}, {
  name: 'DocuSign',
  src: slug('docusign')
}, {
  name: 'SAP',
  src: slug('sap')
}, {
  name: 'Oracle',
  src: slug('oracle')
}, {
  name: 'Workday',
  src: slug('workday')
}, {
  name: 'Okta',
  src: slug('okta')
},
// Next 15 top business apps
{
  name: 'Notion',
  src: slug('notion')
}, {
  name: 'Asana',
  src: slug('asana')
}, {
  name: 'Jira',
  src: slug('jira')
}, {
  name: 'Atlassian',
  src: slug('atlassian')
}, {
  name: 'Zendesk',
  src: slug('zendesk')
}, {
  name: 'Stripe',
  src: slug('stripe')
}, {
  name: 'Adobe',
  src: slug('adobe')
}, {
  name: 'GitHub',
  src: slug('github')
}, {
  name: 'GitLab',
  src: slug('gitlab')
}, {
  name: 'Trello',
  src: slug('trello')
}, {
  name: 'Monday',
  src: slug('mondaydotcom')
}, {
  name: 'Airtable',
  src: slug('airtable')
}, {
  name: 'Box',
  src: slug('box')
}, {
  name: 'Calendly',
  src: slug('calendly')
}, {
  name: 'Mailchimp',
  src: slug('mailchimp')
}];
const LogoTile = ({
  name,
  src
}: {
  name: string;
  src: string;
}) => <div className="flex-shrink-0 mx-6 md:mx-8 h-7 flex items-center gap-2.5 opacity-90 hover:opacity-100 transition-opacity duration-300" title={name} data-id="element-155">
    <img src={src} alt={name} className="h-5 md:h-6 w-auto max-w-[40px] object-contain" loading="lazy" data-id="element-156" />
    <span className="text-sm md:text-base font-medium text-neutral-700 whitespace-nowrap" data-id="element-157">
      {name}
    </span>
  </div>;
export function LogoMarquee() {
  return <section className="py-12 md:py-14 bg-white border-y border-neutral-200/70 overflow-hidden" data-id="element-158">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8 md:mb-10" data-id="element-159">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-2xl md:text-4xl font-serif text-center max-w-3xl mx-auto leading-tight" data-id="element-160">
          Integrate AI across the core platforms your workforce already uses.
        </motion.h2>
      </div>

      {/* Marquee with edge fade mask */}
      <div className="relative w-full" style={{
      maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)'
    }} data-id="element-161">
        <motion.div className="flex w-max" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 60,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-162">
          {/* Render the list twice for a seamless loop */}
          {[...logos, ...logos].map((logo, i) => <LogoTile key={`${logo.name}-${i}`} name={logo.name} src={logo.src} data-id="element-163" />)}
        </motion.div>
      </div>
    </section>;
}